<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'
  import MetaPage from '@/components/layout/MetaPage'

  export default {
    name: 'ResetPasswordPage',
    components: {
      MetaPage,
    },
    metaInfo() {
      return {
        title:
          this.isAuthenticated ?
            this.$t('meta.reset-password.title_change') :
            this.$t('meta.reset-password.title_reset'),
      }
    },
    data() {
      return {
        user_id: '',
        hash: '',
        password: '',
        passwordConfirm: '',
        currentPassword: '',
        form_error: null,
        isStatusVisible: false,
      }
    },
    computed: {
      ...mapState('auth', {
        errors: 'errors',
        pending: 'pending',
        message: 'message',
        isAuthenticated: 'status',
      }),
      ...mapState('auth', ['settings']),
    },
    mounted() {
      this.user_id = this.$route.query.user_id
      this.hash = this.$route.query.hash
    },
    destroyed() {
      this.clearForm()
      this.clearMessage()
    },
    methods: {
      ...mapActions('auth', [
        'resetPassword',
        'changePassword',
        'clearMessage',
      ]),
      clearForm() {
        this.password = ''
        this.passwordConfirm = ''
        this.currentPassword = ''
      },
      onSubmit() {
        this.form_error = null
        if (this.password !== this.passwordConfirm) {
          this.form_error = this.$t('my_account.reset_password.errors.not_equal')
          return false
        }
        if (this.isAuthenticated) {
          this.changePassword({
            current_password: this.currentPassword,
            new_password: this.password,
            new_password_confirm: this.passwordConfirm,
          }).then(_ => {
            if (this.errors.length) return false
            this.$nextTick(() => {
              this.clearForm()
              this.$refs.form.reset()
              this.isStatusVisible = true
            })
          })
        } else {
          this.resetPassword({
            user_id: this.user_id,
            hash: this.hash,
            new_password: this.password,
            new_password_confirm: this.passwordConfirm,
          }).then(_ => {
            if (this.errors.length) return false
            this.$nextTick(() => {
              this.clearForm()
              this.$refs.form.reset()
              this.isStatusVisible = true
            })
          })
        }
      },
    },
  }
</script>
